import { render, staticRenderFns } from "./UnsavedDataModal.vue?vue&type=template&id=e8af6084&scoped=true&"
import script from "./UnsavedDataModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8af6084",
  null
  
)

export default component.exports